import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function ExpectationsSection() {
  return <section className="py-24 px-4 bg-[#0c1425]" data-id="element-48">
      <div className="max-w-3xl mx-auto text-center" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-50">
          <h2 className="text-3xl md:text-4xl font-serif text-cream mb-8" data-id="element-51">
            Lo que puedes esperar en 7 noches
          </h2>

          <p className="text-xl text-amber-200/60 mb-12" data-id="element-52">
            No te voy a vender fantasía. Te voy a vender dirección.
          </p>

          <div className="bg-[#1a2744] p-8 rounded-2xl border border-white/5 mb-12 text-left inline-block w-full" data-id="element-53">
            <ul className="space-y-4 text-lg text-amber-50/90" data-id="element-54">
              <li className="flex items-center" data-id="element-55">
                <span className="w-2 h-2 bg-amber-500 rounded-full mr-4" data-id="element-56"></span>
                Reducir despertares (no necesariamente eliminarlos)
              </li>
              <li className="flex items-center" data-id="element-57">
                <span className="w-2 h-2 bg-amber-500 rounded-full mr-4" data-id="element-58"></span>
                Conseguir al menos 1 tramo más largo de sueño para ti
              </li>
              <li className="flex items-center" data-id="element-59">
                <span className="w-2 h-2 bg-amber-500 rounded-full mr-4" data-id="element-60"></span>
                Tener claridad sobre qué está causando el patrón
              </li>
              <li className="flex items-center" data-id="element-61">
                <span className="w-2 h-2 bg-amber-500 rounded-full mr-4" data-id="element-62"></span>
                Dejar de sentir que estás adivinando
              </li>
            </ul>
          </div>

          <div className="space-y-4" data-id="element-63">
            <p className="text-amber-200/60 uppercase tracking-widest text-sm" data-id="element-64">
              El verdadero cambio
            </p>
            <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-2xl md:text-3xl font-serif" data-id="element-65">
              <span className="text-amber-100/50" data-id="element-66">Pasas de "¿qué hago?"</span>
              <ArrowRight className="hidden md:block text-amber-500" data-id="element-67" />
              <span className="text-gold-gradient font-bold" data-id="element-68">
                a "ya sé qué hacer".
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}